<template>
  <tbody class="is-editable">
    <tr>
      <td class="c-table__cell--middle reminder-id-cell">
        <p class="reminder-id-cell__text">
          {{ message.reminder_id }}
        </p>
      </td>
      <td class="c-table__cell--middle">
        <div class="mini-preview-container">
          <template v-if="isReminder && firstSchedule">
            <div class="mini-preview-card">
              <div class="mini-preview-card__body">
                <div class="mini-preview-card__content">
                  <div v-if="message.badge_image_url" class="mini-preview-card__badge-row">
                    <img :src="message.badge_image_url" class="mini-preview-card__badge" />
                    <div class="mini-preview-card__url">{{ message.click_url }}</div>
                  </div>
                  <div v-else class="mini-preview-card__url">{{ message.click_url }}</div>
                  <div class="mini-preview-card__title">{{ replacePlaceholders(firstSchedule.message_title) }}</div>
                  <div class="mini-preview-card__text">{{ replacePlaceholders(firstSchedule.message_text) }}</div>
                </div>
                <div v-if="resolvedIconUrl" class="mini-preview-card__icon">
                  <img :src="resolvedIconUrl" />
                </div>
              </div>
              <div v-if="message.large_image_url" class="mini-preview-card__image">
                <img :src="message.large_image_url" />
              </div>
            </div>
          </template>
          <template v-else>
            <div class="mini-preview-card">
              <div class="mini-preview-card__body">
                <div class="mini-preview-card__content">
                  <div v-if="message.badge_image_url" class="mini-preview-card__badge-row">
                    <img :src="message.badge_image_url" class="mini-preview-card__badge" />
                    <div class="mini-preview-card__url">{{ message.click_url }}</div>
                  </div>
                  <div v-else class="mini-preview-card__url">{{ message.click_url }}</div>
                  <div class="mini-preview-card__title">{{ replacePlaceholders(message.message_title) }}</div>
                  <div class="mini-preview-card__text">{{ replacePlaceholders(message.message_text) }}</div>
                </div>
                <div v-if="resolvedIconUrl" class="mini-preview-card__icon">
                  <img :src="resolvedIconUrl" />
                </div>
              </div>
              <div v-if="message.large_image_url" class="mini-preview-card__image">
                <img :src="message.large_image_url" />
              </div>
            </div>
          </template>
        </div>
      </td>
      <td class="c-table__cell--middle c-table__cell--center">
        <span class="deliver-count-badge">{{ scheduleCount }}通</span>
      </td>
      <td class="c-table__cell--middle">
        <reminder-condition-summary :condition="message.condition" mode="minimap" />
      </td>
      <td class="c-table__cell--middle c-table__cell--center">
        <template v-if="hasWorkingTime">
          <div class="working-time-range">
            <span>{{ workingStartFormatted }}</span>
            <span class="working-time-range__separator">〜</span>
            <span>{{ workingEndFormatted }}</span>
          </div>
        </template>
      </td>
      <td class="c-table__cell--middle c-table__cell--center">
        <span :class="message.deliver_flag === 1 ? 'deliver-badge deliver-badge--active' : 'deliver-badge deliver-badge--stopped'">{{ displayDeliverFlag }}</span>

        <div class="c-table-editable">
          <ul class="c-table-editable-list">
            <li v-if="message.deliver_flag === 1" class="c-table-editable-list__item">
              <a class="c-btn c-btn--white c-btn--circle" @click="onStopClick">
                <div class="c-btn__text c-btn__text--balloon">停止する</div>
                <div class="c-icon c-icon--gray-3 u-wh20" style="width: 27px !important; height: 27px !important;"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <use xlink:href="/assets/img/sprite.svg#stop" />
                </svg>
                </div>
              </a>
            </li>
            <li v-if="message.deliver_flag === 0" class="c-table-editable-list__item">
              <!-- 配信条件レコード (message.condition) が無いメッセージは「配信条件未設定」扱いのため、
                             ON ボタンを is-completed (opacity 0.5 + cursor not-allowed) で無効化し、バルーンで理由を明示する。 -->
              <a
                class="c-btn c-btn--white c-btn--circle c-btn--no-underline"
                :class="{ 'is-completed': !hasCondition }"
                @click="onStartClick"
              >
                <!-- 標準の .c-btn__text--balloon は width: 80px 固定なので、
                                 長文になる無効化バルーンでは wide 修飾で幅を広げて折返させる。 -->
                <div
                  class="c-btn__text c-btn__text--balloon"
                  :class="{ 'c-btn__text--balloon-wide': !hasCondition }"
                >{{ hasCondition ? '配信開始する' : '配信条件が未設定のため配信開始できません' }}</div>
                <div class="c-icon-on-btn">ON</div>
              </a>
            </li>
            <li class="c-table-editable-list__item">
              <a class="c-btn c-btn--white c-btn--circle" href="#edit" @click="onEditClick">
                <div class="c-btn__text c-btn__text--balloon">編集する</div>
                <div class="c-icon c-icon--gray-3 u-wh20">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <use xlink:href="/assets/img/sprite.svg#edit" />
                  </svg>
                </div>
              </a>
            </li>
            <li v-if="message.deliver_flag === 1" class="c-table-editable-list__item">
              <a class="c-btn c-btn--white c-btn--circle" @click="onReviewClick">
                <div class="c-btn__text c-btn__text--balloon">確認する</div>
                <div class="c-icon c-icon--gray-3 u-wh20">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <use xlink:href="/assets/img/sprite.svg#review" />
                  </svg>
                </div>
              </a>
            </li>
            <li class="c-table-editable-list__item">
              <a class="c-btn c-btn--white c-btn--circle" href="#trash" @click="onDeleteClick">
                <div class="c-btn__text c-btn__text--balloon">削除する</div>
                <div class="c-icon c-icon--gray-3 u-wh20">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <use xlink:href="/assets/img/sprite.svg#trash" />
                  </svg>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
export default {
  props: {
    message: Object,
    defaultIconUrl: String,
    operatorLabels: Object,
  },
  emits: ["delete-click","stop-click","edit-click","review-click","start-click"],
  computed: {
    isReminder: function () {
      return this.message.schedules && this.message.schedules.length > 0;
    },
    sortedSchedules: function () {
      if (!this.isReminder) return [];
      return this.message.schedules.slice().sort(function (a, b) {
        return (a.schedule_index || 0) - (b.schedule_index || 0);
      });
    },
    firstSchedule: function () {
      if (!this.isReminder) return null;
      return this.message.schedules.find(s => s.schedule_index === 0) || this.message.schedules[0];
    },
    displayMessageTitle: function () {
      if (this.message.message_title) return this.message.message_title;
      if (this.firstSchedule) return this.firstSchedule.message_title;
      return '';
    },
    displayMessageText: function () {
      if (this.message.message_text) return this.message.message_text;
      if (this.firstSchedule) return this.firstSchedule.message_text;
      return '';
    },
    resolvedIconUrl: function () {
      return this.message.icon_url || this.defaultIconUrl;
    },
    scheduleCount: function () {
      if (this.isReminder) return this.message.schedules.length;
      return 1;
    },
    hasWorkingTime: function () {
      return this.message.working_start_time != null && this.message.working_end_time != null;
    },
    workingStartFormatted: function () {
      var v = this.message.working_start_time;
      return String(Math.floor(v / 100)).padStart(2, '0') + ':' + String(v % 100).padStart(2, '0');
    },
    workingEndFormatted: function () {
      var v = this.message.working_end_time;
      return String(Math.floor(v / 100)).padStart(2, '0') + ':' + String(v % 100).padStart(2, '0');
    },
    displayDeliverFlag: function () {
      return this.message.deliver_flag === 1 ? '配信中' : '停止中';
    },
    // 配信条件レコード (ReminderMessageCondition) が存在するかどうか。
    // ReminderConditionSummary の「配信条件未設定」表示と同じルール (condition 自体が null かどうか) で判定する。
    hasCondition: function () {
      return !!this.message.condition;
    },
  },
  methods: {
    replacePlaceholders: function (text) {
      if (!text) return text;
      var placeholders = this.message.placeholders || [];
      placeholders.forEach(function (ph) {
        if (ph.placeholder_key) {
          var replacement = ph.default_value || '{{' + ph.placeholder_key + '}}';
          text = text.split('{{' + ph.placeholder_key + '}}').join(replacement);
          text = text.split('{' + ph.placeholder_key + '}').join(replacement);
        }
      });
      return text;
    },
    onDeleteClick: function () {
      this.$emit('delete-click', this.message);
    },
    onStopClick: function () {
      this.$emit('stop-click', this.message);
    },
    onEditClick: function () {
      this.$emit('edit-click', this.message);
    },
    onReviewClick: function () {
      this.$emit('review-click', this.message);
    },
    onStartClick: function () {
      // 配信条件未設定のときは押下無効 (バルーンで理由表示済み)。
      if (!this.hasCondition) return;
      this.$emit('start-click', this.message);
    },
  },
};
</script>

<style scoped>
/* 標準 .c-btn__text--balloon は width: 80px / 1行前提。
   配信条件未設定 ON ボタンのバルーンは長文になるため、幅と折返しを広げる修飾クラス。 */
.c-btn__text--balloon.c-btn__text--balloon-wide {
    width: 220px;
    right: -100px;
    line-height: 1.4;
    white-space: normal;
    padding: 6px 8px;
}

.mini-preview-container {
    display: flex;
    gap: 10px;
    padding: 6px 0;
    overflow-x: auto;
}

.mini-preview-card {
    position: relative;
    background: #fff;
    border: 1.5px solid #ccc;
    border-radius: 8px;
    min-width: 220px;
    max-width: 280px;
    flex-shrink: 0;
    overflow: hidden;
}

.mini-preview-card__label {
    position: absolute;
    top: 0;
    left: 0;
    background: #5b9bd5;
    color: #fff;
    font-size: 11px;
    font-weight: bold;
    padding: 2px 10px;
    border-radius: 0 0 6px 0;
    z-index: 1;
}

.mini-preview-card__body {
    display: flex;
    padding: 8px 10px;
    gap: 8px;
}

.mini-preview-card__label + .mini-preview-card__body {
    padding-top: 24px;
}

.mini-preview-card__content {
    flex: 1;
    min-width: 0;
    overflow: hidden;
}

.mini-preview-card__badge-row {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 3px;
}

.mini-preview-card__badge {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
}

.mini-preview-card__url {
    font-size: 11px;
    color: #666;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 3px;
}

.mini-preview-card__badge-row .mini-preview-card__url {
    margin-bottom: 0;
}

.mini-preview-card__title {
    font-size: 13px;
    font-weight: bold;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 2px;
}

.mini-preview-card__text {
    font-size: 11px;
    color: #666;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.4;
}

.mini-preview-card__icon {
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    border-radius: 4px;
    overflow: hidden;
    background: #eee;
}

.mini-preview-card__icon img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.mini-preview-card__image {
    width: 100%;
    overflow: hidden;
}

.mini-preview-card__image img {
    width: 100%;
    display: block;
}

.list-condition-minimap {
    font-size: 12px;
    line-height: 1.5;
    padding: 4px 0;
}

.list-condition-minimap__join {
    margin-bottom: 4px;
}

.list-condition-minimap__badge {
    display: inline-block;
    font-size: 11px;
    font-weight: 700;
    padding: 1px 8px;
    border-radius: 10px;
    background: #d8f0f6;
    color: #209bb9;
}

.list-condition-minimap__row {
    display: block;
    padding-left: 1.2em;
    text-indent: -1.2em;
    color: #333;
    word-break: break-all;
}

.list-condition-minimap__row::before {
    content: '- ';
}

.list-condition-minimap__row + .list-condition-minimap__row {
    margin-top: 4px;
}

.list-condition-minimap__empty {
    color: #999;
    font-style: italic;
}

.working-time-range {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 13px;
    line-height: 1.4;
    color: #333;
}

.working-time-range__separator {
    color: #888;
    font-size: 12px;
}

.deliver-count-badge {
    display: inline-block;
    font-size: 14px;
    font-weight: normal;
    color: #333;
}

.deliver-badge {
    display: inline-block;
    font-size: 11px;
    font-weight: 700;
    padding: 2px 12px;
    border-radius: 10px;
}

.deliver-badge--active {
    background: #d8f0f6;
    color: #209bb9;
}

.deliver-badge--stopped {
    background: #e8e8e8;
    color: #888;
}

/*
 * リマインダーIDセル: 任意の長さのIDが入っても列幅 (m-w120/u-w120 = 120px) を超えず、
 * 折り返しでテーブルレイアウトを保つ。スペースを含まない長いIDでも改行できるよう
 * word-break: break-all を併用する。
 */
.reminder-id-cell {
    word-break: break-all;
    overflow-wrap: anywhere;
}
.reminder-id-cell__text {
    margin: 0;
    line-height: 1.5;
    word-break: break-all;
    overflow-wrap: anywhere;
}

</style>

<style>
.p-message-result__data .c-table tbody tr td {
    font-size: 14px;
}
.u-text-ellipsis {
  width: 100%;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
}

.u-text-ellipsis:not(:hover) {
  text-overflow: ellipsis;
}

.u-text-ellipsis:hover span,
.u-text-ellipsis:focus span {
  display: inline-block;
  animation-name: scroll-text;
  animation-duration: 7s;
  animation-timing-function: linear;
  animation-delay: 0s;
  animation-iteration-count: infinite;
  animation-direction: normal;
}

.c-btn--no-underline {
    text-decoration: none !important;
    border-bottom: none !important;
}

.c-icon-on-btn {
    width: 27px;
    height: 27px;
    border-radius: 50%;
    background-color: #b0b0b0;
    color: #fff;
    font-size: 11px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
}

@keyframes scroll-text {
  0% {
    transform: translateX(0%);
  }
  90% {
    transform: translateX(-100%);
  }
  95% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(0%);
  }
}
</style>
